module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PC-Insurance","short_name":"PCI","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c851277f2e8bc727ff22cb8502eb4dba"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-K9WZN3T","includeInDevelopment":false,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/builds/pcfinancial/pcf-engineering/pc-services/pci/pcs-pci-publicsite/src/locales","languages":["en","fr"],"defaultLanguage":"en","redirect":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/themes/phoenix/typography"},
    },{
      plugin: require('../node_modules/@loblaw/gatsby-plugin-akamai-bot-manager/gatsby-browser.js'),
      options: {"plugins":[],"whitelist":["pcinsurance.ca"]},
    },{
      plugin: require('../node_modules/@loblaw/gatsby-plugin-pcs-cookie-banner/gatsby-browser.js'),
      options: {"plugins":[],"domainScript":"018df558-8235-7895-bb0e-3d61d495d753-test","publicFolder":"/builds/pcfinancial/pcf-engineering/pc-services/pci/pcs-pci-publicsite/public","domainList":["www.pcinsurance.ca",".pcinsurance.ca"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
